/* eslint-disable no-nested-ternary */
/* eslint max-len: 0, react/no-danger: 0, dot-notation: 0 */
import React from 'react';
import classnames from 'classnames';
import {
  DropdownButton,
  MenuItem,
  FormControl,
} from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment-timezone';
import qs from 'qs';
import Pagination from 'components/v2/PaginationV2';
import Spinner from 'components/ui/LoadingCircle';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import { titleize, humanize, underscored } from 'underscore.string';
import { getPickupStop, getDeliverStop } from 'helpers/stops';
import ShipmentStore from 'stores/ShipmentStore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import MarketsActionCreators from 'actions/MarketActionCreators';
import UserActionCreators from 'actions/UserActionCreators';
import MarketsStore from 'stores/MarketsStore';
import CustomerSearch from 'components/site/customer-search';
import ShipmentWebAPIUtils, { getFileStatus } from 'utils/ShipmentWebAPIUtils';
import ShipmentStatusFilter from 'components/modules/shipments/ShipmentStatusFilter';
import ShipmentTypeFilter from 'components/modules/shipments/ShipmentTypeFilter';
import MarketTypeFilter from 'components/modules/shipments/MarketTypeFilter';
import CargomaticSelect from 'components/v2/select';
import {
  shipmentTypes,
  shipmentStatuses,
} from 'components/modules/shipments/mappings';
import CustomerSearchStore from 'stores/CustomerSearchStore';
import SessionStore from 'stores/SessionStore';
import DriverActionCreators from 'actions/DriverActionCreators';
import DateRangeFilter from 'components/time/DateRangeFilter';
import ChangeUserModal from 'components/modules/shipments/ChangeUserModal';
import AssignDriverModal from 'components/modules/shipments/AssignDriverModal';
import LocationAutosuggest from 'components/site/location-autosuggest';
import Shipment from 'components/modules/shipments/Shipment';
import ShipmentTracking from 'components/modules/shipments/ShipmentTracking';
import Container from 'components/v2/container';
import Card from 'components/v2/card';
import ClockIcon from 'components/v2/icons/ClockIcon';
import DownloadIcon from 'components/v2/icons/DownloadIcon';
import AutocompleteSearch from 'components/v2/AutocompleteSearch';
import Alert from 'components/ui/Alert';
import ShipmentCard from 'components/ui/tailwind/ShipmentCard';
import { massUpdateActions } from 'constants/MassUpdates';
import DriverStore from 'stores/DriverStore';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import { isProd } from 'helpers/helper_functions';
import BulkAddYardsModal from 'components/modules/yards/BulkAddYardsModal';
import { isDrayageShipment } from 'helpers/shipment-types';
import { getDefaultDateRangeFilter } from 'helpers/date-range';
import { getShipmentPreferenceType } from 'helpers/shipments';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { TMS } from 'constants/tms';
import UserStore from '../../../../stores/UserStore';
import DriverAutocomplete from '../../drivers/DriverAutocomplete';
import AddAppointmentModal from '../../../ui/tailwind/modals/AddAppointmentModal';

import EquipmentNumberSearch from './EquipmentNumberSearch';
import ShipmentList from './ShipmentList';
import ShipmentListColumns from './ShipmentListColumns';
import ShipmentListFilters from './ShipmentListFilters';
import ItemSelection from '../../exceptions/ItemSelection';
import FilterItem from './FilterItem';
import MassUpdateModal from '../MassUpdateModal';

import AdminMapping from './AdminMapping';
import ShipperMapping from './ShipperMapping';
import CarrierMapping from './CarrierMapping';
import BulkBOLGenerationModel from '../BulkBOLGenerationModel';
import BulkGenerateRateConfirmation from '../BulkGenerateRateConfirmationModal';
import ConfirmAssignCarrierModal from '../ConfirmAssignCarrierModal';

const MAX_ENTRIES = 20000;
// const POLL = 60000;
const shipmentDateFields = [
  'pickup_by',
  'pickup_after',
  'deliver_by',
  'deliver_after',
];

const userFields = [
  'exclude_master_shipper',
  'master_shipper',
  'shipper',
  'carrier',
  'driver',
];

const AWAITING_EMPTY_DELIVERY = 'awaiting_empty_delivery';

const quickFilterMap = {
  TODAY: 'TODAY',
  TODAY_FUTURE: 'TODAY_FUTURE',
  LAST_15: 'LAST_15',
  LAST_30: 'LAST_30',
  CUSTOM: 'CUSTOM',
  NO_APPT: 'NO_APPT',
};

const QUICK_FILTERS = [...Object.values(quickFilterMap)];

function massUpdateAllowed(shipments) {
  return shipments.find((s) => s.current && !s.canceled);
}

const determineActiveFilter = (props, filter) => {
  if (filter === quickFilterMap.NO_APPT) {
    return props.appointmentExistsActive;
  }
  return props.active === filter;
};

const QuickFilters = (props) => {
  const { t } = props;
  return (
    <div className="mb-6">
      <label className="form-label mb-1">
        <div className="flex items-center space-x-1">
          <span className="">{t('QUICK_TIME_FILTERS')}</span>
          <ClockIcon size="small" className="w-5 h-5" />
        </div>
      </label>
      <div className="flex flex-wrap items-center -mx-2">
        {QUICK_FILTERS.map((localizationSlug) => {
          const active = determineActiveFilter(props, localizationSlug);

          const classNames = classnames({
            button: true,
            border: !active,
            flex: true,
            rounded: true,
            'items-center': true,
            'text-blue': !active,
            'bg-white': !active,
            'text-white': active,
            'bg-blue': active,
            'border-solid': !active,
            'border-blue': !active,
            'hover:bg-blue': true,
            'hover:text-white': true,
          });

          if (localizationSlug === 'CUSTOM') {
            return (
              <div className="px-2 mb-2" key={underscored(localizationSlug)}>
                <div>
                  <DateRangeFilter
                    className="dropdown-filter-wrapper"
                    onChange={props.onCustomSelect}
                    key={underscored(localizationSlug)}
                    startKey="pickup"
                    endKey="deliver"
                    initialStart={moment().subtract(3, 'days')}
                    initialEnd={moment().endOf('day')}
                    label={titleize(t(localizationSlug))}
                  />
                </div>
              </div>
            );
          }
          return (
            <div key={underscored(localizationSlug)} className="px-2 mb-2">
              <div className={classNames}>
                <button
                  className=""
                  onClick={() => props.onClick(localizationSlug)}
                >
                  {titleize(t(localizationSlug))}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const getColumnTextForExport = (text) => {
  const currentColText = text.trim().toLowerCase();

  switch (currentColText) {
    case 'origin':
      return 'Starting Origin';
    case 'destination':
      return 'Finishing Destination';
    default:
      return text;
  }
};

const QUICK_STATUSES = [
  'en_route',
  'arrived',
  'needs_appt',
  'accepted',
  'in_progress',
  'job_canceled',
  'job_closed',
];

class ShipmentListModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.configureShipmentList(props);
  }

  configureShipmentList(props) {
    const { t } = this.props;
    const queryFilters = qs.parse(props.location.search.substr(1));
    let filtersMeta = {};
    const user = SessionStore.getUser();
    const userType = user._type;
    const config = {
      columns: ShipmentListColumns.SHIPPER_COLUMNS,
      availableColumns: ShipmentListColumns.SHIPPER_COLUMNS,
      availableFilters: ShipmentListFilters.ADMIN_FILTERS,
    };
    let quick_date = quickFilterMap.LAST_15;
    let disableInitialFilter = false;
    let initialFilterDays = 15;
    let hideColumnProperties;
    let shipperColumns;

    switch (userType) {
      case 'Admin':
        config.columns = AdminMapping.columns;
        config.availableColumns = AdminMapping.columns;
        config.availableFilters = ShipmentListFilters.ADMIN_FILTERS;
        config.activeColumns = AdminMapping.columns;
        config.showBulkActions = true;
        break;
      case 'Shipper':
        hideColumnProperties = user?.hide_column_properties ?? [];
        shipperColumns = ShipperMapping.columns.filter(
          (shipperColumn) =>
            !hideColumnProperties.includes(shipperColumn.dataField),
        );
        config.columns = shipperColumns;
        config.availableColumns = shipperColumns;
        config.availableFilters = ShipmentListFilters.SHIPPER_FILTERS;
        config.activeColumns = shipperColumns;
        queryFilters.shipper = [user._id];
        config.showBulkActions = false;
        break;
      case 'Carrier':
        config.columns = CarrierMapping.columns;
        config.availableColumns = CarrierMapping.columns;
        config.activeColumns = CarrierMapping.columns;
        config.availableFilters = ShipmentListFilters.CARRIER_FILTERS;
        config.carrierFilter = ShipmentListFilters.CARRIER_SELECT_FILTER;
        queryFilters.carrier = [user._id];
        filtersMeta = { [user._id]: user.name };
        config.showBulkActions = true;
        disableInitialFilter = true;
        quick_date = quickFilterMap.LAST_30;
        initialFilterDays = 30;
        break;
      default:
    }

    const defaultDates = getDefaultDateRangeFilter({
      startValue: initialFilterDays,
      startTimeUnit: 'days',
    });

    return {
      loaded: true,
      bulkAction: '',
      config: config,
      // showShipmentDetail: false,
      showAddAppointmentModal: false,
      showSendRateConfirmationModal: false,
      showBulkYardsModal: false,
      appointmentShipment: null,
      appointmentStop: null,
      activeShipment: null,
      totalEntries: 0,
      showError: false,
      errorMessage: t('ADD_CRITERIA_TO_REDUCE_NUMBER_OF_ITEMS'),
      showAssignDriverModal: false,
      showConfirmAssignCarrierModal: false,
      showConfirmAssignDriverModal: false,
      brokerCarrierDriver: null,
      showChangeShipperModal: false,
      showMassUpdateModal: false,
      showBulkBOLGenerationModel: false,
      showChangeConsigneeModel: false,
      selected: [],
      selectedIds: [],
      // selectAll: false,
      user: user,
      isCarrier: userType === 'Carrier',
      drivers: [],
      done: false,
      hasMultiAccountAccess: false,
      shipments: [],
      equipmentResults: {},
      showBulkActions: config.showBulkActions,
      columns: config.columns,
      availableColumns: config.availableColumns,
      activeColumns: config.activeColumns,
      hiddenColumns: [],
      availableFilters: config.availableFilters,
      newFilter:
        userType === 'Carrier'
          ? {}
          : _.findWhere(config.availableFilters, { attribute: 'reference' }) ||
            {},
      filtersMeta,
      quick_date: quickFilterMap.LAST_15,
      quick_status: null,
      appointmentExistsActive: false,
      account_manager: null,
      sales_rep: null,
      salesReps: [],
      activeAdminReps: [],
      refSearch: '',
      carrierIntegrations: TMS,
      filters: {
        shipper: queryFilters['shipper'] ? queryFilters['shipper'] : [],
        carrier: queryFilters['carrier'] ? queryFilters['carrier'] : [],
        driver: queryFilters['driver'] ? queryFilters['driver'] : [],
        status: queryFilters['status'] ? queryFilters['status'] : [],
        shipment_types: queryFilters['shipment_types']
          ? queryFilters['shipment_types']
          : [],
        market: queryFilters['market'] ? queryFilters['market'] : [],
        tags: queryFilters['tags'] ? queryFilters['tags'] : [],
        reference: queryFilters['reference'] ? queryFilters['reference'] : [],
        origin: queryFilters['origin'] ? queryFilters['origin'] : [],
        destination: queryFilters['destination']
          ? queryFilters['destination']
          : [],
        page: queryFilters['page'] ? parseInt(queryFilters['page'], 10) : 1,
        pickup_after: queryFilters['pickup_after']
          ? queryFilters['pickup_after']
          : [],
        per_page: 25,
        initialFilterDays,
        pickup_by: queryFilters['pickup_by'] ? queryFilters['pickup_by'] : [],
        deliver_after: disableInitialFilter
          ? []
          : queryFilters['deliver_after']
            ? queryFilters['deliver_after']
            : [defaultDates.start],
        deliver_by: disableInitialFilter
          ? []
          : queryFilters['deliver_by']
            ? queryFilters['deliver_by']
            : [defaultDates.end],
        near_origin: queryFilters['near_origin']
          ? queryFilters['near_origin']
          : [],
        near_destination: queryFilters['near_destination']
          ? queryFilters['near_destination']
          : [],
        equipments: queryFilters['equipments']
          ? queryFilters['equipments']
          : [],
        awaiting_empty_delivery: queryFilters[AWAITING_EMPTY_DELIVERY]
          ? queryFilters[AWAITING_EMPTY_DELIVERY]
          : [],
        missing_docs: queryFilters['missing_docs']
          ? queryFilters['missing_docs']
          : [],
        appointments_exist: queryFilters['appointments_exist']
          ? queryFilters['appointments_exist']
          : [],
        shipment_id: queryFilters['shipment_id']
          ? queryFilters['shipment_id']
          : [],
        carrier_name: queryFilters['carrier_name']
          ? queryFilters['carrier_name']
          : [],
        bulk_booking_id: queryFilters['bulk_booking_id']
          ? [queryFilters['bulk_booking_id']]
          : [],
        carrier_integrations: [],
      },
    };
  }

  async getContexts() {
    const user = SessionStore.getUser();
    const { data: accessRequests } =
      await UserWebAPIUtils.getAccountAccessRequests(user._id);

    _.map(this.state ? this.state.accounts : [], (account) => {
      const userType = user._type;
      if (
        account === user._id &&
        userType === 'Carrier' &&
        !this.state.hasMultiAccountAccess
      ) {
        const { config } = this.state;
        let requiredFilters = _.map(config.availableFilters, (filter) => {
          if (filter.attribute !== 'carrier_name') {
            return filter;
          }
        });
        requiredFilters = _.compact(requiredFilters);
        config.availableFilters = requiredFilters;
        let requiredColumns = _.map(config.availableColumns, (column) => {
          if (column.dataField !== 'carrier_name') {
            return column;
          }
        });
        requiredColumns = _.compact(requiredColumns);
        config.activeColumns = requiredColumns;
        config.availableColumns = requiredColumns;
      }
    });

    if (accessRequests) {
      const accounts = accessRequests
        .filter(
          (accountAccess) =>
            accountAccess.grantee._id === user._id &&
            accountAccess.status === 'approved',
        )
        .map((accountAccess) => accountAccess.grantor);
      if (accounts) {
        this.setState({
          accounts: accounts,
          hasMultiAccountAccess: accounts.length > 0,
        });
      }
    }
  }

  async componentDidMount() {
    MarketsStore.addChangeListener(this.handleMarketsStoreChange); // Connecting to store
    MarketsActionCreators.findMarkets(); // API calls made from action creator
    CustomerSearchStore.addChangeListener(this.handleSearchResultsReturned);
    ShipmentStore.addChangeListener(this.handleShipperChange);
    ShipmentStore.addChangeListener(this.handleShipmentChange);
    ShipmentStore.addBulkUpdateChangeListener(this.handleShipmentChange);
    UserStore.addChangeListener(this._onUserStoreChange);
    const { user } = this.state;
    if (user && user._type === 'Carrier') {
      DriverActionCreators.getAuthorizedDriversForCarrier(this.state.user._id);
      DriverStore.addChangeListener(this.handleDriverStoreChange);
    }

    if (user && user._type === 'Admin') {
      UserActionCreators.getSalespeople();
      UserActionCreators.getAdminUsers({ active: true });
    }

    this.getCustomerNames();
    await this.queryShipments();
    this.getContexts();
  }

  _onUserStoreChange = () => {
    const _salesReps = UserStore.getSalesReps() || [];
    const _activeAdmins = UserStore.getAdminUsers() || [];
    const salesReps = _salesReps.map((salesPerson) => ({
      slug: salesPerson.email,
      name: salesPerson.email,
    }));
    const activeAdminReps = _activeAdmins.map((activeAdmin) => ({
      slug: activeAdmin.email,
      name: activeAdmin.email,
    }));

    this.setState({
      salesReps: _.sortBy(salesReps, 'name'),
      activeAdminReps: _.sortBy(activeAdminReps, 'name'),
    });
  };

  getShipmentDetailComponent(shipment) {
    if (SessionStore.isAdmin()) {
      return (
        <div className="px-4 rounded bg-grey-light">
          <Shipment
            shipment={shipment}
            showCloseButton
            onClose={() => {
              this.setState({
                activeShipment: null,
                showShipmentDetails: false,
              });
            }}
          />
        </div>
      );
    }
    return <ShipmentTracking shipment={shipment} />;
  }

  // Handler for driver store update
  handleDriverStoreChange = () => {
    const drivers = DriverStore.getAuthorizedDrivers();
    this.setState({ drivers });
  };

  handleWindowSave = (updates) => {
    const { appointmentShipment: job, appointmentStop: stop } = this.state;

    const updatedStop = {
      ...stop,
      ...updates,
    };

    ShipmentsActionCreators.updateShipmentStopWindow(job, updatedStop, updates);
    this.setState({
      showAddAppointmentModal: false,
      appointmentShipment: null,
      appointmentStop: null,
    });
  };

  // handleEditAppointmentWindow = (stop) => {
  //   this.setState({
  //     showAddAppointmentModal: true,
  //     appointmentStop: stop,
  //   });
  // };

  handleWindowEdit = (appointmentWindowType, shipment) => {
    let stop;
    if (appointmentWindowType === 'pickup') {
      stop = getPickupStop(shipment);
    } else {
      stop = getDeliverStop(shipment);
    }

    this.setState({
      showAddAppointmentModal: true,
      appointmentShipment: shipment,
      appointmentStop: stop,
    });
  };

  // convertDateToTimezone(date, timezone) {
  //   return moment(date).tz(timezone, false).format();
  // }

  handleCancelWindowEdit = () => {
    this.setState({
      showAddAppointmentModal: false,
      appointmentShipment: null,
      appointmentStop: null,
    });
  };

  handleShipmentClick(shipment) {
    this.setState({ activeShipment: shipment, showShipmentDetails: true });
  }

  // handleCloseShipmentDetail() {
  //   this.setState({ activeShipment: null, showShipmentDetails: false });
  // }

  componentWillUnmount() {
    MarketsStore.removeChangeListener(this.handleMarketsStoreChange);
    CustomerSearchStore.removeChangeListener(this.handleSearchResultsReturned);
    ShipmentStore.removeChangeListener(this.handleShipperChange);
    ShipmentStore.removeChangeListener(this.handleShipmentChange);
    ShipmentStore.removeBulkUpdateChangeListener(this.handleShipmentChange);
    UserStore.removeChangeListener(this._onUserStoreChange);
    if (this.state.user._type === 'Carrier') {
      DriverStore.removeChangeListener(this.handleDriverStoreChange);
    }
  }

  getCustomerNames() {
    const {
      filters: { shipper, carrier, driver },
    } = this.state;
    const customers = _.unique([...shipper, ...carrier, ...driver]);
    CustomersActionCreators.getCustomers(customers);
  }

  getColumn(key) {
    return this.state.availableFilters.find((f) => f.attribute === key);
  }

  getActiveFilterKeys() {
    const filters = this.state.filters || {};
    return Object.keys(filters).filter((key) => filters[key].length > 0);
  }

  getSelectedShipments() {
    return this.state.selected
      .filter((s) => s.current && !s.canceled)
      .map((s) => s._id);
  }

  getSelectedShipmentContainers() {
    return this.state.selected
      .filter((s) => s.current && !s.canceled)
      .map((s) => {
        return {
          id: s._id,
          equipments: s.equipments,
          shipment_id: s.shipment_id,
          market_id: s.market.market_id,
        };
      });
  }

  handleMarketsStoreChange = () => {
    let markets = MarketsStore.getMarkets();
    markets = _.pluck(markets, 'name');
    this.setState({ markets });
  };

  canChangeShipper() {
    return SessionStore.getUserRoles().indexOf('finance') > -1;
  }

  areShipmentWithInactiveStatus = () => {
    const { selected = [] } = this.state;
    const INACTIVE_SHIPMENT_STATUS = ['job_closed', 'job_canceled'];
    return selected.some((s) => INACTIVE_SHIPMENT_STATUS.includes(s?.status))
  }

  areShipmentsWithSameType = () => {
    const { selected } = this.state;
    if (!selected.length) {
      return;
    }
    const firstShipmentPreferences = getShipmentPreferenceType(
      selected[0].shipment_type,
    );
    return selected.every((shipment) => {
      return (
        getShipmentPreferenceType(shipment.shipment_type) ===
        firstShipmentPreferences
      );
    });
  };

  areShipmentsWithSameShipper = () => {
    const { selected } = this.state;

    // we can change carrier only for shipments
    // with same shipper:
    // https://cargomatic.atlassian.net/browse/CARGO-4589?focusedCommentId=59681
    return selected.every((shipment) => {
      const shipperId = shipment.shipper.id || shipment.shipper._id;
      const firstShipperId = selected[0].shipper.id || selected[0].shipper._id;
      return shipperId === firstShipperId;
    });
  };

  canChangeDriver() {
    return (
      this.areShipmentsWithSameShipper() && this.areShipmentsWithSameType() && !this.areShipmentWithInactiveStatus()
    );
  }

  canChangeCarrier() {
    const { selected } = this.state;

    return (
      SessionStore.getUserRoles().indexOf('finance') > -1 &&
      selected.every((s) => s.current && !s.canceled) &&
      this.areShipmentsWithSameShipper() &&
      this.areShipmentsWithSameType() &&
      !this.areShipmentWithInactiveStatus()
    );
  }

  massUpdateAllowed() {
    return massUpdateAllowed(this.state.selected);
  }

  sendBulkBOLMails() {
    return this.state.selected.every(
      (s) => s.current && !s.canceled && s.shipment_type !== 'drayage',
    );
  }

  canChangeConsignee() {
    return this.state.selected.every(
      (s) => s.current && !s.canceled && s.shipment_type === 'drayage',
    );
  }

  canAddBulkYards() {
    return this.state.selected.every(
      (s) => s.current && !s.canceled && isDrayageShipment(s),
    );
  }

  handleShipperChange = () => {
    this.setState((prevState) => {
      const updatedJobs = ShipmentStore.getUpdatedShipperJobs();
      const shipments = prevState.shipments.map((current) => {
        return _.extend(
          current,
          _.findWhere(updatedJobs, { _id: current._id }),
        );
      });
      return { shipments };
    });
  };

  handleShipmentChange = () => {
    const { shipments: currentShipments, selectedIds } = this.state;

    const updatedShipments = ShipmentStore.getShipments();
    const shipments = currentShipments.map((current) => {
      const match = _.findWhere(updatedShipments, { _id: current._id });
      if (match) {
        const updated = _.extend(current, match);
        return updated;
      }
      return current;
    });

    const selected = shipments.filter((s) => selectedIds.includes(s._id));
    this.setState({
      shipments,
      selected,
    });
  };

  handleSearchResultsReturned = () => {
    const results = CustomerSearchStore.getSearchResults();
    const resultsMap = (results || []).reduce(
      (map, item) => ({
        ...map,
        [item._id]: item.company_name || item.name,
      }),
      {},
    );

    this.setState((prevState) => {
      const filtersMeta = {
        ...prevState.filtersMeta,
        ...resultsMap,
      };
      return { filtersMeta };
    });
  };

  handlePaginationSelect(page) {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters.page = page;
        return {
          // selectAll: false,
          selected: [],
          filters,
          page,
        };
      },
      () => {
        this.queryShipments();
      },
    );
  }

  async queryShipments() {
    const queryFilters = {};
    const { filters } = this.state;
    if (filters.bulk_booking_id.length) {
      const response = await getFileStatus(filters.bulk_booking_id[0]);
      const { result } = response.entity;
      if (result?.booked_shipments?.length) {
        queryFilters._id = result.booked_shipments.map(
          (shipment) => shipment._id,
        );
      }
    } else {
      const activeFilterKeys = this.getActiveFilterKeys();

      activeFilterKeys.forEach((key) => {
        // prevent empty value filters from being passed to query
        const cleanValues = [];
        _.each(filters[key], (val) => {
          if (
            (typeof val === 'string' || val instanceof String) &&
            val.length
          ) {
            cleanValues.push(val.trim());
          } else {
            cleanValues.push(val);
          }
        });
        if (cleanValues.length) {
          queryFilters[key] = cleanValues;
        }
      });
      queryFilters.page = filters.page;
      queryFilters.per_page = filters.per_page;
      queryFilters.sort = { _id: -1 };
    }

    this.setState({ done: false }, () => {
      ShipmentWebAPIUtils.getShipmentsV2(
        queryFilters,
        (res) => {
          // Hack for not using hooks or change listensers correctly
          if (!window.location.href.includes('/shipments')) {
            return;
          }
          const { selectedIds } = this.state;

          const shipments = res.entity.items;
          const selected = shipments.filter((s) => selectedIds.includes(s._id));

          this.setState(
            (prevState) => {
              const page =
                res.entity.pages < prevState.page ? 1 : prevState.page;
              return {
                equipmentResults: res.entity.equipment,
                shipments,
                selected,
                done: true,
                totalEntries: res.entity.totalCount,
                pages: res.entity.totalPages,
                page,
                showError: false,
              };
            },

            () => {
              if (queryFilters.shipper && queryFilters.shipper.length > 50) {
                queryFilters.shipper = [];
              }
              const queryString = qs.stringify(queryFilters);
              this.props.history.push({
                pathname: '/shipments',
                search: `?${queryString}`,
              });
            },
          );
        },
        (res) => {
          console.log('Error', res.body);
          this.setState({ done: true });
        },
      );
    });
  }

  exportShipmentsToCSV() {
    if (this.state.totalEntries > MAX_ENTRIES) {
      this.setState({ showError: true });
      return;
    }

    this.setState({ done: false }, () => {
      const columns = this.state.columns.map((column) =>
        getColumnTextForExport(column.text),
      );

      ShipmentWebAPIUtils.getShipmentsForCsv(
        this.state.filters,
        columns,
        () => {
          this.setState({ done: true });
        },
        () => {
          this.setState({ done: true });
        },
      );
    });
  }

  itemSelected(newColumns) {
    const activeColumns = [];
    const hiddenColumns = [];

    this.state.availableColumns.forEach((column) => {
      if (newColumns.indexOf(column.localizationSlug) > -1)
        activeColumns.push(column);
      else hiddenColumns.push(column.localizationSlug);
    });
    this.setState({ activeColumns, hiddenColumns });
  }

  handleFilterSelection(key) {
    const { isCarrier } = this.state;
    const filters = isCarrier
      ? this.state.config.carrierFilter
      : this.state.availableFilters;
    const filter = _.findWhere(filters, { attribute: key });

    if (!_.isEmpty(filter)) {
      this.setState({ newFilter: filter }, () => {});
      if (filter.attribute === AWAITING_EMPTY_DELIVERY) {
        this.handleAwaitingEmptyDelivery();
      }
    }
  }

  handleFilterChange(value) {
    if (this.state.isCarrier) {
      this.setState({ refSearch: value });
    } else {
      this.setState((prevState) => {
        const newFilter = prevState.newFilter;
        newFilter.value = value || '';
        return { newFilter };
      });
    }
  }

  addNewFilter(carrierFilter) {
    const { filters } = this.state;
    const newFilter = carrierFilter || this.state.newFilter;
    if (newFilter.value) {
      const filter = newFilter.attribute;
      const SINGLE_FILTERS = ['origin', 'destination'];

      if (SINGLE_FILTERS.indexOf(filter) > -1) {
        filters[newFilter.attribute] = [newFilter.value];
      } else {
        filters[newFilter.attribute].push(newFilter.value);
      }
      newFilter.value = '';
      filters.page = 1;

      this.setState(
        {
          // selectAll: false,
          refSearch: '',
          page: 1,
          selected: [],
          filters,
          newFilter: {},
        },
        () => {
          this.queryShipments();
        },
      );
    }
  }

  canFilterBeRemoved(key) {
    switch (this.state.user._type) {
      case 'Shipper':
        if (key === 'shipper') return false;
        break;
      case 'Carrier':
        if (
          this.state.hasMultiAccountAccess &&
          this.state.filters.carrier.length > 1
        ) {
          break;
        }
        if (key === 'carrier') return false;
        break;
      default:
    }

    return true;
  }

  removeFilter(filter, value) {
    // Handle shipper can find all shipments;
    if (!this.canFilterBeRemoved(filter)) return;

    const filters = this.state.filters;

    if (filter.indexOf('pickup') > 0) {
      filters['pickup_by'] = [];
      filters['pickup_after'] = [];
    } else if (
      filter.indexOf('deliver') > 0 &&
      filter !== AWAITING_EMPTY_DELIVERY
    ) {
      filters['pickup_by'] = [];
      filters['pickup_after'] = [];
    } else {
      const index = filters[filter].indexOf(value);
      filters[filter].splice(index, 1);
    }

    filters.page = 1;

    if (filter.indexOf('near') > -1) {
      filters[filter] = [];
    }

    const newStateObj = {
      filters,
      selectAll: false,
      selected: [],
    };

    if (filter.indexOf('appointments_exist') > -1) {
      newStateObj.appointmentExistsActive = false;
    }

    this.setState(newStateObj, () => {
      this.queryShipments();
    });
  }

  handleCustomerSelect = (type) => (_name, customer) => {
    this.setState(
      (prevState) => {
        const filters = {
          ...prevState.filters,
          [type]: [...(prevState.filters[type] || []), customer.value],
        };
        const filtersMeta = {
          ...prevState.filtersMeta,
          [customer.value]: customer.name || customer.company_name,
        };

        return {
          filters,
          filtersMeta,
          newFilter: {},
        };
      },
      () => {
        this.queryShipments();
      },
    );
  };

  handleCarrierSelect = (carrier) => {
    if (!this.state.filters.carrier.includes(carrier._id)) {
      this.setState(
        (prevState) => {
          const filters = {
            ...prevState.filters,
            carrier: [...(prevState.filters.carrier || []), carrier._id],
          };

          const filtersMeta = {
            ...prevState.filtersMeta,
            [carrier._id]: carrier.name,
          };
          return {
            filters,
            filtersMeta,
          };
        },
        () => {
          this.queryShipments();
        },
      );
    }
  };

  handleShipmentStatusFilter(active) {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters.status = active;
        return { filters };
      },
      () => this.queryShipments(),
    );
  }

  handleMarketTypeFilter(market) {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters.market = market;
        return { filters };
      },
      () => this.queryShipments(),
    );
  }

  handleShipmentTypeFilter(shipment_types) {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters.shipment_types = shipment_types.map((el) => el.name);
        return { filters };
      },
      () => this.queryShipments(),
    );
  }

  handleQuickDateFilter(filter) {
    const filters = this.state.filters;
    filters.pickup_by = [];
    filters.pickup_after = [];

    if (this.state.quick_date === filter) {
      this.setState(
        {
          quick_date: null,
          filters: {
            ...filters,
            pickup_by: [],
            pickup_after: [],
            deliver_by: [],
            deliver_after: [],
          },
        },
        this.queryShipments,
      );
    } else {
      const noAppointmentsReset = {
        filters: {
          ...filters,
          // appointments_exist: [true],
        },
        // appointmentExistsActive: false,
      };

      switch (filter) {
        case quickFilterMap.TODAY_FUTURE:
          this.setState(
            {
              quick_date: quickFilterMap.TODAY_FUTURE,
              ...noAppointmentsReset,
            },
            () => {
              this.handleDateRange({
                filterType: 'deliver',
                start: moment().startOf('day'),
                end: moment().endOf('day').add(5, 'days'),
              });
            },
          );
          break;
        case quickFilterMap.TODAY:
          this.setState(
            {
              quick_date: quickFilterMap.TODAY,
              ...noAppointmentsReset,
            },
            () => {
              this.handleDateRange({
                filterType: 'deliver',
                start: moment().startOf('day'),
                end: moment().endOf('day'),
              });
            },
          );
          break;
        case quickFilterMap.LAST_15:
          this.setState(
            {
              quick_date: quickFilterMap.LAST_15,
              ...noAppointmentsReset,
            },
            () => {
              this.handleDateRange({
                filterType: 'deliver',
                start: moment().startOf('day').subtract(15, 'days'),
                end: moment().endOf('day'),
              });
            },
          );
          break;
        case quickFilterMap.LAST_30:
          this.setState(
            {
              quick_date: quickFilterMap.LAST_30,
              ...noAppointmentsReset,
            },
            () => {
              this.handleDateRange({
                filterType: 'deliver',
                start: moment().startOf('day').subtract(30, 'days'),
                end: moment().endOf('day').add(5, 'days'),
              });
            },
          );
          break;
        case quickFilterMap.NO_APPT:
          this.setState((prevState) => {
            const filtersObj = {
              ...filters,
            };
            if (filters.appointments_exist) {
              delete filtersObj.appointments_exist;
            } else {
              filtersObj.appointments_exist = [false];
            }
            return {
              filters: filtersObj,
              // quick_date: !prevState.appointmentExistsActive ? [] : prevState.quick_date,
              quick_date: prevState.quick_date,
              appointmentExistsActive: filtersObj.appointments_exist,
            };
          }, this.queryShipments);
          break;
        default:
          this.queryShipments();
      }
    }
  }

  handleDateRange = ({ filterType, start, end }) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        const defaultDates = getDefaultDateRangeFilter({
          startValue: filters.initialFilterDays,
          startTimeUnit: 'days',
        });
        if (filterType === 'clear') {
          filters.deliver_after = [defaultDates.start];
          filters.deliver_by = [defaultDates.end];
          filters.pickup_by = [];
          filters.pickup_after = [];
        } else if (filterType === 'pickup') {
          filters.pickup_after = [moment(start).startOf('day').toISOString()];
          filters.pickup_by = end
            ? [moment(end).endOf('day').toISOString()]
            : [];
        } else {
          filters.deliver_after = [moment(start).startOf('day').toISOString()];
          filters.deliver_by = end
            ? [moment(end).endOf('day').toISOString()]
            : [];
        }
        return {
          filters,
        };
      },
      () => this.queryShipments(),
    );
  };

  handleLocationAddressNearbySelect = (item) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters || {};
        const key = prevState.newFilter.attribute;
        filters[key].push(item.lng, item.lat);
        return {
          filters,
          newFilter: {},
        };
      },
      () => this.queryShipments(),
    );
  };

  handleEquipmentFilter = (item) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        if (item.indexOf(',') > -1 && item.indexOf(' ') > -1) {
          return;
        }
        if (item.indexOf(',') > -1) {
          const equipments = item.split(',');
          filters.equipments = equipments;
        } else if (item.indexOf(' ') > -1) {
          const equipments = item.split(' ');
          filters.equipments = equipments;
        } else {
          filters.equipments = [item];
        }
        filters.status = [
          'accepted',
          'in_progress',
          'scheduled',
          'en_route',
          'arrived',
          'needs_appt',
        ];
        filters.shipment_types = ['drayage', 'rail'];
        return { filters };
      },
      () => this.queryShipments(),
    );
  };

  handleLocationNameSelect = (item) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters || {};
        filters[prevState.newFilter.attribute].push(item.name);

        const filtersMeta = { ...prevState.filtersMeta };

        filtersMeta[item.value] = item.name;
        return {
          filters,
          filtersMeta,
          name: item.name,
          newFilter: {},
        };
      },
      () => {
        this.queryShipments();
      },
    );
  };

  assignDriver(shipment, driver) {
    if (shipment.length > 0) {
      const shipments = shipment;
      const driverId =
        driver._type === 'Carrier' ? driver.default_driver : driver._id;
      ShipmentsActionCreators.bulkAssignDriver(driverId, shipments);
      this.setState(
        {
          selected: [],
          // selectAll: false,
        },
        () => this.queryShipments(),
      );
    } else {
      ShipmentsActionCreators.assignDriver(shipment, driver);
    }
  }

  handleSelection(shipment, checked) {
    const { selectedIds: currentSelectedIds, shipments } = this.state;

    let selectedIds;
    if (checked) {
      selectedIds = [...currentSelectedIds, shipment._id];
    } else {
      const index = currentSelectedIds.findIndex((s) => s === shipment._id);
      if (index !== -1) {
        selectedIds = [
          ...currentSelectedIds.slice(0, index),
          ...currentSelectedIds.slice(index + 1),
        ];
      } else {
        selectedIds = [...currentSelectedIds];
      }
    }

    const selected = shipments.filter((s) => selectedIds.includes(s._id));
    this.setState({
      selectedIds,
      selected,
      // selectAll: false,
    });
  }

  handleSelectAll(checked) {
    const { shipments } = this.state;

    let selected = [];
    let selectedIds = [];

    if (checked) {
      selected = [...shipments];
      selectedIds = selected.map((s) => s._id);
    }

    this.setState({
      selectedIds,
      selected,
      // selectAll: checked,
    });
  }

  handleBulkAction(key) {
    switch (key) {
      case 'ChangeCarrier':
        this.setState({ showChangeCarrierModal: true });
        break;
      case 'ChangeShipper':
        this.setState({ showChangeShipperModal: true });
        break;
      case 'Assign':
        this.setState({ showAssignDriverModal: true });
        break;
      case 'CompleteStop':
        this.doMassUpdate(massUpdateActions.COMPLETE_STOP);
        break;
      case 'UpdateAppointmentWindow':
        this.doMassUpdate(massUpdateActions.UPDATE_APPOINTMENT_WINDOW);
        break;
      case 'ETA':
        this.doMassUpdate(massUpdateActions.EDIT_ESTIMATED_ARRIVAL);
        break;
      case 'Arrival':
        this.doMassUpdate(massUpdateActions.EDIT_ARRIVAL);
        break;
      case 'Discharge':
        this.doMassUpdate(massUpdateActions.EDIT_DISCHARGE);
        break;
      case 'LFD':
        this.doMassUpdate(massUpdateActions.EDIT_LAST_FREE_DAY);
        break;
      case 'sendBillOfLading':
        this.setState({ showBulkBOLGenerationModel: true });
        break;
      case 'changeConsignee':
        this.setState({ showChangeConsigneeModel: true });
        break;
      case 'generateRateConfirmation':
        this.setState({ showSendRateConfirmationModal: true });
        break;
      case 'addYardsInBulk':
        this.setState({ showBulkYardsModal: true });
        break;
      default:
    }
  }

  doMassUpdate(action) {
    this.setState({
      showMassUpdateModal: true,
      bulkAction: action,
    });
  }

  // dateFiltered() {
  //   const filters = this.state.filters;
  //   return filters.pickup_by.length > 0 || filters.deliver_by.length > 0;
  // }

  renderAddAppointmentModal() {
    if (!this.state.showAddAppointmentModal) {
      return null;
    }

    const { appointmentShipment, appointmentStop } = this.state;

    return (
      <AddAppointmentModal
        stop={appointmentStop}
        shipment={appointmentShipment}
        show={this.state.showAddAppointmentModal}
        onSave={this.handleWindowSave}
        onHide={this.handleCancelWindowEdit}
      />
    );
  }

  renderFilterItems() {
    const { t } = this.props;
    const { isCarrier } = this.state;
    const filters = isCarrier
      ? this.state.config.carrierFilter
      : this.state.availableFilters;
    return filters.map((filter) => (
      <MenuItem key={filter.attribute} eventKey={filter.attribute}>
        {titleize(t(filter.localizationSlug, { count: filter.count }))}
      </MenuItem>
    ));
  }

  renderActiveFilters() {
    const { t } = this.props;

    const filters = this.state.filters || {};
    const filtersMeta = this.state.filtersMeta;
    const activeFilterKeys = this.getActiveFilterKeys();
    const renderedFilters = activeFilterKeys.reduce((runningList, key) => {
      if (!this.state.hasMultiAccountAccess && key === 'carrier') {
        return runningList;
      }
      const renderedFilterValues = filters[key].map((value, i) => {
        let displayValue = '';
        let localize = true;
        if (userFields.includes(key)) {
          localize = false;
          displayValue = filtersMeta[value] || value;
        } else if (shipmentDateFields.includes(key)) {
          localize = false;
          displayValue = moment(value).format('L');
        }
        const column = this.getColumn(key);
        const labelHeader = t(key.toUpperCase());
        const localizeValue = localize
          ? t(sluggify(displayValue || humanize(value)))
          : displayValue || humanize(value);
        const color = column ? column.color : 'info';
        let label = `${labelHeader}: ${titleize(localizeValue)}`;

        if (key === AWAITING_EMPTY_DELIVERY) {
          label = `${labelHeader}`;
        }
        // Do not change tags formatting
        if (key === 'tags') {
          label = `${labelHeader}: ${value}`;
        }

        const filterKey = `${key}-${i}`;

        return (
          <div className="flex-grow-0 flex-shrink-0 px-2 mb-2" key={filterKey}>
            <FilterItem
              color={color}
              label={label}
              onRemoveFilter={() => this.removeFilter(key, value)}
            />
          </div>
        );
      });
      return runningList.concat(renderedFilterValues);
    }, []);
    return renderedFilters;
  }

  handleAwaitingEmptyDelivery() {
    const { filters } = this.state;
    filters.awaiting_empty_delivery = [AWAITING_EMPTY_DELIVERY];
    filters.shipment_type = ['drayage', 'rail'];
    filters.status = ['accepted', 'in_progress'];
    this.setState(
      {
        filters,
      },
      () => {
        this.queryShipments();
      },
    );
  }

  handleCustomSelect({ filterType, start, end }) {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        if (filterType === 'clear') {
          filters.page = 1;
          return { quick_date: quickFilterMap.LAST_15, filters };
        }
        if (filterType === 'pickup') {
          filters.deliver_by = [];
          filters.deliver_after = [];
        } else {
          filters.pickup_by = [];
          filters.pickup_after = [];
        }
        return { quick_date: quickFilterMap.CUSTOM, filters };
      },
      () => {
        this.handleDateRange({ filterType, start, end });
      },
    );
  }

  handleDriverSelect = (driver) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        const key = driver._type.toLowerCase();
        filters[key].push(driver._id);
        const filtersMeta = { ...prevState.filtersMeta };
        filtersMeta[driver._id] = `${driver.first_name} ${driver.last_name}`;
        return {
          filters,
          filtersMeta,
          newFilter: {},
        };
      },
      () => {
        this.queryShipments();
      },
    );
  };

  handleManagedCustomerSelect = async (item, type) => {
    const { slug: email } = item;
    const query = {
      [type]: email,
    };
    const items = await UserWebAPIUtils.getManagedCustomers(query);

    const { filters, filtersMeta } = this.state;
    const shippers = [];
    items.forEach((i) => {
      shippers.push(i._id);
      filtersMeta[i._id] = `${i.company_name}`;
    });

    filters.shipper = _.uniq(shippers);

    this.setState({ filters, filtersMeta }, () => {
      this.queryShipments();
    });
  };

  handleCarrierIntegrationsSelect = async (item) => {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters.carrier_integrations = _.isEmpty(item) ? [] : [item.name];
        return { filters };
      },
      () => this.queryShipments(),
    );
  };

  addMissingDocsFilter() {
    this.setState(
      (prevState) => {
        const filters = prevState.filters;
        filters['missing_docs'].push(true);

        const filtersMeta = { ...prevState.filtersMeta };
        filtersMeta['missing_docs'] = `Missing Documentation`;
        return {
          filters,
          filtersMeta,
          newFilter: {},
        };
      },
      () => {
        this.queryShipments();
      },
    );
  }

  renderCarrierFilter() {
    if (
      this.state.availableFilters.length > 0 &&
      this.state.user._type === 'Carrier'
    ) {
      const carrierFilters = this.state.availableFilters.filter(
        (availableFilter) => {
          return !_.findWhere(this.state.config.carrierFilter, availableFilter);
        },
      );
      return (
        <div className="mt-4 mx-2 flex flex-wrap gap-2 items-center space-x-3">
          {carrierFilters.map((filter) => {
            if (
              filter.display === 'Carrier' &&
              !this.state.hasMultiAccountAccess
            ) {
              return null;
            }
            return this.renderNewFilter(filter);
          })}
        </div>
      );
    }
  }

  renderNewFilter(carrierFilter) {
    const { t } = this.props;
    const newFilter = carrierFilter || this.state.newFilter;
    const { isCarrier } = this.state;
    if (!_.isEmpty(newFilter)) {
      if (newFilter.type === 'text') {
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <div className="flex items-center">
              <div>
                <FormControl
                  className="form-field"
                  value={isCarrier ? this.state.refSearch : newFilter.value}
                  onChange={(e) => this.handleFilterChange(e.target.value)}
                  placeholder={t(newFilter.placeholderLocalizationSlug)}
                  type="text"
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      this.addNewFilter(
                        isCarrier
                          ? {
                              value: this.state.refSearch,
                              attribute: newFilter.attribute,
                            }
                          : null,
                      );
                    }
                  }}
                />
              </div>
              <button
                className="button button-hollow-green"
                onClick={() =>
                  this.addNewFilter(
                    isCarrier
                      ? {
                          value: this.state.refSearch,
                          attribute: newFilter.attribute,
                        }
                      : null,
                  )
                }
              >
                {titleize(t('APPLY'))}
              </button>
            </div>
          </div>
        );
      }
      if (newFilter.type === 'missing_docs') {
        return (
          <div>
            <label className="form-label mb-1">
              {t(newFilter.localizationSlug)}
            </label>
            <div className="flex flex-wrap">
              <button
                className="button button-hollow-green"
                onClick={() => this.addMissingDocsFilter()}
              >
                {titleize(t('APPLY'))}
              </button>
            </div>
          </div>
        );
      }
      if (newFilter.type === 'carrier_associated') {
        // update this once data is coming from the token
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <div className="inline-block">
              <AutocompleteSearch
                searchKey="name"
                badgeLabel={t('CARRIER')}
                placeholder={t('SEARCH_FOR_CARRIERS')}
                inputStyle={{ width: '150px', maxHeight: '200' }}
                items={[]}
                autocompleteOptions={this.state ? this.state.accounts : []}
                onSelect={this.handleCarrierSelect}
                nGramLength={1}
              />
            </div>
          </div>
        );
      }
      if (['carriers', 'shippers'].includes(newFilter.customerType)) {
        const label = `${t('SEARCH_FOR')} ${titleize(
          t(newFilter.localizationSlug),
        )}`;
        return (
          <div className="form-group">
            <label className="mb-1 form-label">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <CustomerSearch
              onSelect={this.handleCustomerSelect(newFilter.type)}
              type={newFilter.customerType}
              placeholder={label}
            />
          </div>
        );
      }

      if (['master_shippers'].includes(newFilter.customerType)) {
        const label = `${t('SEARCH_FOR')} ${titleize(
          t(newFilter.localizationSlug),
        )}`;

        const labelForExludeMasterShipper = `${t('SEARCH_FOR')} ${titleize(
          t('EXCLUDE_MASTER_ACCOUNT'),
        )}`;
        return (
          <div className="form-group inline-block flex">
            <div className="mr-2">
              <label className="mb-1 form-label">
                {titleize(t(newFilter.localizationSlug))}
              </label>
              <CustomerSearch
                onSelect={this.handleCustomerSelect(newFilter.type)}
                type={newFilter.customerType}
                placeholder={label}
              />
            </div>
            <div>
              <label className="mb-1 form-label">
                {titleize(t('EXCLUDE_MASTER_ACCOUNT'))}
              </label>
              <CustomerSearch
                onSelect={this.handleCustomerSelect('exclude_master_shipper')}
                type="exclude_master_shippers"
                placeholder={labelForExludeMasterShipper}
              />
            </div>
          </div>
        );
      }

      if (newFilter.type === 'driver' && this.state.user._type === 'Carrier') {
        // const label = `Search for ${this.state.newFilter.customerType}`;
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <div className="">
              <DriverAutocomplete
                className="offer-field py-2"
                drivers={this.state.drivers}
                value={this.state.driverInput || ''}
                onDriverSelected={({ driver }) =>
                  this.handleDriverSelect(driver)
                }
                onChange={(driverInput) => {
                  this.setState({
                    driverInput,
                  });
                }}
              />
            </div>
          </div>
        );
      }
      if (newFilter.type === 'driver') {
        const label = t('SEARCH_FOR_DRIVERS');
        return (
          <div>
            <label className="form-label mb-1">
              {t(newFilter.localizationSlug)}
            </label>
            <CustomerSearch
              onSelect={this.handleCustomerSelect('driver')}
              type={newFilter.customerType}
              placeholder={label}
            />
          </div>
        );
      }
      if (newFilter.type === 'status') {
        return (
          <div>
            <label className="form-label pl-2 mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <ShipmentStatusFilter
              className="dropdown-filter-wrapper"
              items={shipmentStatuses}
              actives={this.state.filters.status}
              onChange={(active) => this.handleShipmentStatusFilter(active)}
              buttonClassName="flex button button-green justify-center items-center px-2 text-white"
              iconColor="text-white"
            />
          </div>
        );
      }
      if (newFilter.type === 'market') {
        return (
          <div>
            <label className="form-label mb-1">
              {t('MARKET', { count: 1 })}
            </label>
            <MarketTypeFilter
              className="dropdown-filter-wrapper"
              items={this.state.markets}
              actives={this.state.filters.market}
              onChange={(market) => this.handleMarketTypeFilter(market)}
            />
          </div>
        );
      }

      if (newFilter.type === 'shipment_types') {
        const activeShipmentTypes = () => {
          return shipmentTypes.filter((type) =>
            this.state.filters.shipment_types.includes(type.name),
          );
        };
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <ShipmentTypeFilter
              className="dropdown-filter-wrapper"
              items={shipmentTypes}
              actives={activeShipmentTypes()}
              onChange={(shipment_types) => {
                this.handleShipmentTypeFilter(shipment_types);
              }}
            />
          </div>
        );
      }

      if (newFilter.type === 'daterange') {
        return (
          <div>
            <label className="form-label mb-1 ">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <DateRangeFilter
              className="dropdown-filter-wrapper"
              onChange={this.handleDateRange}
              startKey="pickup"
              endKey="deliver"
              initialStart={moment().subtract(3, 'days')}
              initialEnd={moment().endOf('day')}
            />
          </div>
        );
      }

      if (newFilter.type === 'location_name') {
        // const label = `Search for ${this.state.newFilter.customerType}`;
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <LocationAutosuggest
              id="autosuggest-name"
              name=""
              address=""
              value={newFilter.value}
              suggestions={[{ name: '', address: '' }]}
              callbackSelectedItem={this.handleLocationNameSelect}
            />
          </div>
        );
      }

      if (newFilter.type === 'location_address') {
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <LocationAutosuggest
              id="autosuggest-address"
              name=""
              address=""
              value={newFilter.value}
              suggestions={[{ name: '', address: '' }]}
              callbackSelectedItem={this.handleLocationAddressNearbySelect}
            />
          </div>
        );
      }

      if (newFilter.type === 'equipment') {
        return (
          <div>
            <label className="form-label mb-1">
              {titleize(t(newFilter.localizationSlug))}
            </label>
            <div className="equipment-search-wrapper">
              <EquipmentNumberSearch onRun={this.handleEquipmentFilter} />
            </div>
          </div>
        );
      }

      if (newFilter.type === 'account_manager') {
        return (
          <CargomaticSelect
            selected={this.state.account_manager}
            items={this.state.activeAdminReps}
            info={t('ACCOUNT_MANAGER_REPRESENTATIVE')}
            label={t('ACCOUNT_MANAGER')}
            onSelect={(item) =>
              this.handleManagedCustomerSelect(item, 'account_manager')
            }
            valueKey="slug"
            textKey="name"
          />
        );
      }

      if (newFilter.type === 'sales_rep') {
        return (
          <CargomaticSelect
            selected={this.state.sales_rep}
            items={this.state.salesReps}
            info={t('ACCOUNT_SALES_REP')}
            label={t('SALES_REP')}
            onSelect={(item) =>
              this.handleManagedCustomerSelect(item, 'sales_rep')
            }
            valueKey="slug"
            textKey="name"
          />
        );
      }
    }

    if (newFilter.type === 'carrier_integrations') {
      const {
        filters: { carrier_integrations },
      } = this.state;

      const selectedItem = carrier_integrations.length
        ? TMS.find((tmsItem) => tmsItem.name === carrier_integrations[0]).slug
        : null;

      return (
        <CargomaticSelect
          selected={selectedItem}
          items={this.state.carrierIntegrations}
          label={t('INTEGRATION_TYPE')}
          onSelect={(item) => this.handleCarrierIntegrationsSelect(item)}
          valueKey="slug"
          textKey="slug"
        />
      );
    }

    return null;
  }

  renderAdminBulkActionMenu() {
    const { t } = this.props;
    return (
      <DropdownButton
        id="bulk-actions-dropdown"
        disabled={this.state.selected.length === 0}
        title={t('BULK_ACTIONS')}
        onSelect={(key) => this.handleBulkAction(key)}
        bsSize="small"
        bsStyle="danger"
      >
        <MenuItem eventKey="Assign" disabled={!this.canChangeDriver()}>
          {t('ASSIGN_DRIVER')}
        </MenuItem>
        <MenuItem eventKey="ChangeShipper" disabled={!this.canChangeShipper()}>
          {t('CHANGE_SHIPPER')}
        </MenuItem>
        <MenuItem eventKey="ChangeCarrier" disabled={!this.canChangeCarrier()}>
          {t('CHANGE_CARRIER')}
        </MenuItem>
        <MenuItem eventKey="CompleteStop" disabled={!this.massUpdateAllowed()}>
          {t('COMPLETE_STOP')}
        </MenuItem>
        <MenuItem
          eventKey="UpdateAppointmentWindow"
          disabled={!this.massUpdateAllowed()}
        >
          {t('UPDATE_APPOINTMENT_WINDOW')}
        </MenuItem>
        <MenuItem
          eventKey="sendBillOfLading"
          disabled={!this.sendBulkBOLMails()}
        >
          {t('SEND_BILL_OF_LADING')}
        </MenuItem>
        <AuthorizationWrapper excludedRegions={REGIONS.AP}>
          <MenuItem
            eventKey="changeConsignee"
            disabled={!this.canChangeConsignee()}
          >
            {t('CHANGE_CONSIGNEE')}
          </MenuItem>
        </AuthorizationWrapper>
        <MenuItem eventKey="generateRateConfirmation">
          {t('GENERATE_RATE_CONFIRMATION')}
        </MenuItem>
        {!isProd() && (
          <MenuItem
            eventKey="addYardsInBulk"
            disabled={!this.canAddBulkYards()}
          >
            {t('ADD_YARDS_IN_BULK')}
          </MenuItem>
        )}
      </DropdownButton>
    );
  }

  renderCarrierBulkActionMenu() {
    const { t } = this.props;
    return (
      <DropdownButton
        id="bulk-actions-dropdown"
        disabled={this.state.selected.length === 0}
        title={t('BULK_ACTIONS')}
        onSelect={(key) => this.handleBulkAction(key)}
        bsSize="small"
        bsStyle="danger"
      >
        <MenuItem
          eventKey="ETA"
          disabled={!massUpdateAllowed(this.state.selected)}
        >
          {t('ESTIMATED_ARRIVAL_DATE')}
        </MenuItem>
        <MenuItem
          eventKey="Arrival"
          disabled={!massUpdateAllowed(this.state.selected)}
        >
          {t('ARRIVAL_DATE')}
        </MenuItem>
        <MenuItem
          eventKey="Discharge"
          disabled={!massUpdateAllowed(this.state.selected)}
        >
          {t('DISCHARGE_DATE')}
        </MenuItem>
        <MenuItem
          eventKey="LFD"
          disabled={!massUpdateAllowed(this.state.selected)}
        >
          {t('LAST_FREE_DATE')}
        </MenuItem>
      </DropdownButton>
    );
  }

  clearFilters = () => {
    const { filters } = this.state;
    _.map(filters, (value, key) => {
      switch (key) {
        case 'page':
          filters[key] = 1;
          break;
        case 'per_page':
          filters[key] = 25;
          break;
        default:
          filters[key] = [];
      }
    });

    this.setState(
      {
        quick_date: null,
        account_manager: null,
        sales_rep: null,
        carrier_integrations: null,
        filters,
      },
      () => {
        this.queryShipments();
      },
    );
  };

  render() {
    if (this.state.loaded === false) {
      return <div />;
    }
    const selected = this.state.selected.map((shipment) => shipment._id);
    const availableColumns = this.state.availableColumns.map(
      (column) => column.localizationSlug,
    );
    const activeColumns = this.state.activeColumns.map(
      (column) => column.localizationSlug,
    );

    const page =
      this.state.filters && this.state.filters.page
        ? this.state.filters.page
        : 1;
    const equipmentResultsEnabled =
      this.state.equipmentResults &&
      this.state.equipmentResults.no_active_shipments &&
      this.state.equipmentResults.not_found;

    const isCarrier = this.state.user._type === 'Carrier';
    const isAdmin = this.state.user._type === 'Admin';

    const {
      showChangeCarrierModal,
      showChangeShipperModal,
      showChangeConsigneeModel,
    } = this.state;
    const shipmentsSelected = (selected || []).length > 0;
    const { t } = this.props;
    const {
      filters: { per_page },
    } = this.state;
    const x = page === 1 ? page : (page - 1) * per_page + 1;
    let y = x === 1 ? per_page : x + per_page;

    if (this.state.totalEntries < per_page) {
      y = this.state.totalEntries;
    }

    return (
      <Container className="py-8">
        {this.renderAddAppointmentModal()}
        <div>
          <div>
            <div>
              {this.state.showError && (
                <Alert type="error" className="mb-4">
                  {this.state.errorMessage}
                </Alert>
              )}
              <Card className="mb-6">
                <div className="flex flex-wrap justify-between">
                  <div className="flex flex-wrap -mx-4 mb-4">
                    <div className="px-4">
                      <DropdownButton
                        bsStyle="danger"
                        id="add-filter-dropdown"
                        title={`+ ${t('FILTER')}`}
                        onSelect={(key) => this.handleFilterSelection(key)}
                      >
                        {this.renderFilterItems()}
                      </DropdownButton>
                    </div>
                    <div className="px-4">{this.renderNewFilter()}</div>
                  </div>
                </div>
                {equipmentResultsEnabled &&
                  (this.state.equipmentResults.no_active_shipments.length > 0 ||
                    this.state.equipmentResults.not_found.length > 0) && (
                    <Alert title={t('EQUIPMENT_RESULTS')}>
                      {this.state.equipmentResults.no_active_shipments.length >
                        0 && (
                        <p className="text-sm truncate my-0">
                          {t('NO_ACTIVE_SHIPMENTS')}:{' '}
                          {this.state.equipmentResults.no_active_shipments.join(
                            ', ',
                          )}
                        </p>
                      )}
                      {this.state.equipmentResults.not_found.length > 0 && (
                        <p className="text-sm truncate my-0">
                          {t('NOT_FOUND')}:{' '}
                          {this.state.equipmentResults.not_found.join(', ')}
                        </p>
                      )}
                    </Alert>
                  )}
                <div className="">
                  <label className="form-label mb-1">
                    {t('ACTIVE_FILTERS')}
                  </label>
                  <div className="flex flex-wrap max-h-32 overflow-y-scroll items-center mb-2 -mx-2">
                    {this.renderActiveFilters()}
                  </div>
                </div>
                {!isCarrier && (
                  <div className="mt-4">
                    <QuickFilters
                      active={this.state.quick_date}
                      appointmentExistsActive={
                        this.state.appointmentExistsActive
                      }
                      onClick={(filter) => this.handleQuickDateFilter(filter)}
                      onCustomSelect={({ filterType, start, end }) => {
                        this.handleCustomSelect({ filterType, start, end });
                      }}
                      t={this.props.t}
                    />
                  </div>
                )}
                {isCarrier && (
                  <div className="">
                    <label className="form-label mb-1">
                      {t('ADDITIONAL_FILTERS')}
                    </label>
                    <div className="mb-2 -mx-2">
                      {this.renderCarrierFilter()}
                    </div>
                  </div>
                )}
              </Card>
              {this.state.activeShipment ? (
                <div>
                    <Pagination
                      first
                      last
                      total={this.state.totalEntries}
                      page={this.state.page}
                      perPage={this.state.filters.per_page}
                      onPageClick={this.handlePaginationSelect}
                    />
                  <div className="flex -mx-4">
                    <div className="w-1/4 h-screen px-4 overflow-y-scroll">
                      {this.state.shipments.map((shipment, idx) => {
                        return (
                          <div key={idx} className="mb-2">
                            <ShipmentCard
                              shipment={shipment}
                              active={
                                this.state.activeShipment &&
                                this.state.activeShipment._id === shipment._id
                              }
                              onClick={(id) => this.handleShipmentClick(id)}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex-1 h-screen overflow-y-scroll">
                      {this.state.activeShipment &&
                      this.state.showShipmentDetails ? (
                        <div className="sticky px-4">
                          {this.getShipmentDetailComponent(
                            this.state.activeShipment,
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              {!this.state.activeShipment && (
                <div className="">
                  <div className="flex flex-wrap justify-between items-center">
                    <div className="flex flex-wrap items-center -mx-2 mb-4">
                      <div className="px-2">
                        <ItemSelection
                          disabled={this.state.showShipmentDetails}
                          category={titleize(t('COLUMN', { count: 2 }))}
                          glyph="align-justify"
                          items={availableColumns}
                          active={activeColumns}
                          onChange={(c) => this.itemSelected(c)}
                        />
                      </div>
                      <div className="px-2">
                        {this.state.showBulkActions &&
                          isAdmin &&
                          this.renderAdminBulkActionMenu()}
                        {this.state.showBulkActions &&
                          isCarrier &&
                          this.renderCarrierBulkActionMenu()}
                      </div>
                      <div className="px-2">
                        <button
                          className="button button-hollow-green"
                          onClick={() => this.exportShipmentsToCSV()}
                          disabled={!this.state.done}
                          title={t('EXPORT_CSV')}
                        >
                          <div className="flex items-center space-x-1">
                            <span>{t('EXPORT_CSV')}</span>
                            <DownloadIcon />
                          </div>
                        </button>
                      </div>
                      {isAdmin && (
                        <div className="px-2">
                          <button
                            className="button button-hollow-red"
                            onClick={() => this.clearFilters()}
                          >
                            {t('CLEAR_FILTERS')}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <ShipmentList
                    per_page={this.state.filters.per_page}
                    selected={selected}
                    onHandleSelection={(id, checked) => {
                      this.handleSelection(id, checked);
                    }}
                    onHandleSelectAll={(checked) => {
                      this.handleSelectAll(checked);
                    }}
                    page={page}
                    pages={this.state.pages}
                    totalEntries={this.state.totalEntries}
                    onPaginationSelect={(selectedPage) => {
                      this.handlePaginationSelect(selectedPage);
                    }}
                    done={this.state.done}
                    shipments={this.state.shipments}
                    columns={this.state.activeColumns}
                    hiddenColumns={this.state.hiddenColumns}
                    availableColumns={this.state.availableColumns}
                    availableFilters={this.state.availableFilters}
                    onShipmentIdClick={(id) => this.handleShipmentClick(id)}
                    onWindowEdit={this.handleWindowEdit}
                  />
                </div>
              )}
              {this.state.showMassUpdateModal && (
                <MassUpdateModal
                  shipments={this.getSelectedShipments()}
                  action={this.state.bulkAction}
                  show={this.state.showMassUpdateModal}
                  onHide={() => {
                    this.setState({
                      showMassUpdateModal: false,
                      selected: [],
                      selectedIds: [],
                      // selectAll: false,
                    });
                  }}
                />
              )}
              {this.state.showBulkBOLGenerationModel && (
                <BulkBOLGenerationModel
                  shipments={this.getSelectedShipments()}
                  onHide={() => {
                    this.setState({
                      showBulkBOLGenerationModel: false,
                    });
                  }}
                />
              )}
              {this.state.showSendRateConfirmationModal && (
                <BulkGenerateRateConfirmation
                  selectedShipments={this.getSelectedShipments()}
                  show={this.state.showSendRateConfirmationModal}
                  onHide={() => {
                    this.setState({
                      showSendRateConfirmationModal: false,
                    });
                  }}
                />
              )}
              {shipmentsSelected && (
                <AssignDriverModal
                  shipments={this.state.selected}
                  shipment={_.first(this.state.selected)}
                  show={this.state.showAssignDriverModal}
                  onAssignDriver={(shipment, driver) => {
                    this.assignDriver(shipment, driver);
                  }}
                  onAssignBrokerCarrier={(shipment, driver) =>
                    this.setState({
                      showConfirmAssignDriverModal: true,
                      showAssignDriverModal: false,
                      brokerCarrierDriver: driver,
                    })
                  }
                  onHide={() => this.setState({ showAssignDriverModal: false })}
                />
              )}
              {shipmentsSelected && (
                <ConfirmAssignCarrierModal
                  isOpen={this.state.showConfirmAssignDriverModal}
                  brokerCarrierDriver={this.state.brokerCarrierDriver}
                  shipment={this.state.selected}
                  onConfirm={(shipments, driver) =>
                    this.assignDriver(shipments, driver)
                  }
                  onClose={() =>
                    this.setState({ showConfirmAssignDriverModal: false })
                  }
                />
              )}
              {shipmentsSelected && showChangeShipperModal && (
                <ChangeUserModal
                  jobs={this.state.selected}
                  show={this.state.showChangeShipperModal}
                  type="shipper"
                  onSave={(shipper, selectedJobs) => {
                    ShipmentsActionCreators.updateShipper(
                      shipper,
                      selectedJobs,
                    );
                  }}
                  onHide={() => {
                    this.setState({ showChangeShipperModal: false });
                  }}
                />
              )}
              {shipmentsSelected && showChangeCarrierModal && (
                <ChangeUserModal
                  jobs={this.state.selected}
                  show={this.state.showChangeCarrierModal}
                  type="carrier"
                  onSave={(carrier, selectedJobs) => {
                    ShipmentsActionCreators.updateCarrier(
                      carrier,
                      selectedJobs,
                    );
                  }}
                  onAssignBrokerCarrier={(shipment, carrier) =>
                    this.setState({
                      showConfirmAssignCarrierModal: true,
                      showChangeCarrierModal: false,
                      brokerCarrierDriver: carrier,
                    })
                  }
                  onHide={() => {
                    this.setState({ showChangeCarrierModal: false });
                  }}
                />
              )}
              {shipmentsSelected && (
                <ConfirmAssignCarrierModal
                  isOpen={this.state.showConfirmAssignCarrierModal}
                  brokerCarrierDriver={this.state.brokerCarrierDriver}
                  shipment={this.state.selected}
                  onConfirm={(shipments, carrier) => {
                    ShipmentsActionCreators.updateCarrier(carrier, shipments);
                  }}
                  onClose={() =>
                    this.setState({ showConfirmAssignCarrierModal: false })
                  }
                />
              )}
              {shipmentsSelected && showChangeConsigneeModel && (
                <ChangeUserModal
                  jobs={this.state.selected}
                  show={this.state.showChangeConsigneeModel}
                  type="consignee"
                  onSave={(consignee, selectedJobs) => {
                    ShipmentsActionCreators.updateConsignee(
                      consignee,
                      selectedJobs,
                    );
                  }}
                  onHide={() => {
                    this.setState({ showChangeConsigneeModel: false });
                  }}
                />
              )}
              {this.state.showBulkYardsModal && (
                <BulkAddYardsModal
                  selectedShipmentsData={this.getSelectedShipmentContainers()}
                  show={this.state.showBulkYardsModal}
                  onHide={() => {
                    this.setState({
                      showBulkYardsModal: false,
                    });
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(ShipmentListModule);
